import React from 'react'
import { AlertTriangle, Clock, Shield } from 'lucide-react'

const Urgency: React.FC = () => {
  return (
    <section className="section-padding bg-gradient-to-r from-red-50 to-orange-50">
      <div className="container-max">
        <div className="max-w-4xl mx-auto text-center">
          <div className="flex items-center justify-center mb-6">
            <AlertTriangle className="w-8 h-8 text-red-600 mr-3" />
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              한정 무료 공개
            </h2>
          </div>

          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-red-200">
            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                광고 없이 오직 입소문으로만
                <br />
                이 페이지를 다시 찾기는 어렵습니다
              </p>
              
              <div className="flex items-center justify-center space-x-4 my-8">
                <Clock className="w-6 h-6 text-orange-600" />
                <span className="text-xl font-semibold text-gray-900">
                  AI 시스템 운영 비용으로
                </span>
              </div>
              
              <p className="text-xl font-semibold text-red-600">
                무료 구독은 선착순 제한됩니다
              </p>
              
              <p className="text-lg font-medium text-gray-800">
                지금이 마지막 기회일 수 있습니다
              </p>
            </div>

            <div className="mt-8 p-4 bg-red-50 rounded-lg border border-red-200">
              <div className="flex items-center justify-center space-x-2 text-red-700">
                <Shield className="w-5 h-5" />
                <span className="font-medium">
                  선착순 1,000명 한정 무료 구독
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Urgency
